import type { DialogTree } from '@/types';

const part2Dialog = {
  part2_1: {
    id: 'part2_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.png',
    sfx : "chicken",
    nextDialogId: 'part2_2',
  },
  part2_2: {
    id: 'part2_2',
    speaker: 'Yan',
    text: `Sudah pagi, sebaiknya aku berangkat dengan Diana dan Elsa. Apakah mereka masih di kamar Diana?`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/black.png',
    nextDialogId: 'part2_3',
  },
  part2_3: {
    id: 'part2_1',
    speaker: 'Yan',
    text: ``,
    backgroundImage: '/assets/backdrop/kamar_diana.png',
    sfx : "openDoor",
    nextDialogId: 'part2_4',
  },
  part2_4: {
    id: 'part2_4',
    speaker: 'Yan',
    text: `Sepertinya mereka tidak di kamar.`,
    backgroundImage: '/assets/backdrop/kamar_diana.png',
    nextDialogId: 'part2_5',
  },
  part2_5: {
    id: 'part2_5',
    speaker: 'Yan',
    text: `Apakah nenek sudah bangun?`,
    characterImage: '/assets/character/v2/cyanf.png',
    backgroundImage: '/assets/cutscene/black.png',
    nextDialogId: 'part2_5a',
  },
  part2_5a : {
    id: 'part2_5a',
    speaker: 'Yan',
    text: ``,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/black.png',
    choices: [
      {
        text: 'Sebaiknya aku coba mengetuk pintu nenek untuk memeriksa.',
        nextDialogId: 'part2_6',
      },
      {
        text: 'Sebaiknya jangan mengganggu istirahat nenek',
        nextDialogId: 'part2_7',
      },
    ],
  },
  part2_6: {
    id: 'part2_7',
    speaker: 'Yan',
    text: ``,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/black.png',
    sfx : 'doorKnock',
    nextDialogId: 'part2_6a',
  },
  part2_6a: {
    id: 'part2_7',
    speaker: 'Yan',
    text: `Sepertinya tidak ada respons.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/black.png',
    sfx : 'doorKnock',
    nextDialogId: 'part2_7',
  },
  part2_7: {
    id: 'part2_7',
    speaker: 'Yan',
    text: `Baiklah, saatnya keluar dan eksplorasi desa.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/cutscene/black.png',
    isEnd : true
  },
}

const config: DialogTree = {
  startDialogId: 'day1_opening1',
  nodes: {
    day1_opening1: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Selamat datang Kak!`,
      characterImage: '/assets/character/v2/diana.png',
      backgroundImage: '/assets/backdrop/desa.png',
      nextDialogId: 'day1_opening2',
    },
    day1_opening2: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Akhirnya kamu sampai juga. Sudah lama sekali kita tidak bertemu.`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/desa.png',
      nextDialogId: 'day1_opening3',
    },
    day1_opening3: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Siapa itu bersama kamu?`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/desa.png',
      nextDialogId: 'day1_opening4',
    },
    day1_opening4: {
      id: 'day1_opening4',
      speaker: '',
      text: `Siapa itu bersama kamu?`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/desa.png',
      choices: [
        {
          text: 'Perkenalkan, ini Elsa teman baik ku',
          nextDialogId: 'day1_opening5',
          storyActions : [
              { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : -1} },
          ]
        },
        {
          text: 'Elsa, teman ku yang sangat istimewa',
          nextDialogId: 'day1_opening5',
          storyActions : [
            { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : -1} },
            { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
          ]
        },
        {
          text: 'Elsa adalah teman sekelas ku',
          nextDialogId: 'day1_opening5',
          storyActions : [
            { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
          ]
        },
      ],
    },
    day1_opening5: {
      id: 'day1_opening',
      speaker: '',
      text: `Haloo, aku Elsa, salam kenal semua`,
      characterImage: '/assets/character/v2/elsa.png',
      backgroundImage: '/assets/backdrop/desa.png',
      nextDialogId: 'day1_opening6',
    },
    day1_opening6: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Selamat datang kak Elsa! Semoga betah di desa ini!`,
      characterImage: '/assets/character/v2/diana.png',
      backgroundImage: '/assets/backdrop/desa.png',
      nextDialogId: 'day1_opening7',
    },
    day1_opening7: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Elsa, Aku teman terbaik Yan dari kecil.`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/desa.png',
      nextDialogId: 'day1_opening8',
    },
    day1_opening8: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Ayo, kita masuk dulu, sudah cukup gelap diluar. Nenek sudah menunggu didalam`,
      characterImage: '/assets/character/v2/diana.png',
      backgroundImage: '/assets/backdrop/desa.png',
      nextDialogId: 'day1_opening9',
    },
    day1_opening9: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.png',
      nextDialogId: 'day1_opening10',
      sfx : "openDoor"
    },
    day1_opening10: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Halo nek, apakah nenek sudah istirahat? Yan sudah pulang`,
      characterImage: '/assets/character/v2/diana.png',
      backgroundImage: '/assets/backdrop/kamar_nenek_fill.png',
      nextDialogId: 'day1_opening11',
    },
    day1_opening11: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Silahkan masuk`,
      backgroundImage: '/assets/backdrop/kamar_nenek_fill.png',
      nextDialogId: 'day1_opening12',
    },
    day1_opening12: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Senang sekali masih bisa melihat kamu. `,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.png',
      nextDialogId: 'day1_opening12b',
    },
    day1_opening12b: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Sepertinya waktu nenek sudah tidak lama, nenek sekarang sudah sulit sekali bergerak.`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.png',
      nextDialogId: 'day1_opening13',
    },
    day1_opening13: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Siapa ini bersama kamu? Pacar kamu?`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.png',
      nextDialogId: 'day1_opening14',
    },
    day1_opening14: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.png',
      choices: [
        {
          text: 'Betul nek, perkenalkan ini Elsa',
          nextDialogId: 'day1_opening15',
        },
        {
          text: 'Bukan nek, ini Elsa hanya teman.',
          nextDialogId: 'day1_opening15',
          storyActions : [
            { type: 'addCustomValue', value: {key : "elsa_affinity", value : -1} },
          ]
        },
        {
          text: 'Ini Elsa, temanku dari sekolah.',
          nextDialogId: 'day1_opening15',
        },
      ],
    },
    day1_opening15: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Halo Elsa, selamat datang dan selamat beristirahat.`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.png',
      nextDialogId: 'day1_opening16',
    },
    day1_opening16: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Selamat malam ya`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.png',
      nextDialogId: 'day1_opening17',
    },
    day1_opening17: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/kamar_nenek_fill.png',
      nextDialogId: 'day1_opening18',
    },
    day1_opening18: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Ayo kita beristirahat`,
      backgroundImage: '/assets/backdrop/kamar_nenek_fill.png',
      characterImage: '/assets/character/v2/diana.png',
      nextDialogId: 'day1_opening19',
    },
    day1_opening19: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.png',
      nextDialogId: 'day1_opening20',
      sfx : "openDoor"
    },
    day1_opening20: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Ini kamarku. Malam ini kak Elsa tidur di kamar ku ya!`,
      characterImage: '/assets/character/v2/diana.png',
      backgroundImage: '/assets/backdrop/kamar_diana.png',
      nextDialogId: 'day1_opening20b',
    },
    day1_opening20b: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Aku juga sebaiknya pulang kerumah. Yan, apakah besok ingin mandi bersama di Danau?`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/kamar_diana.png',
      nextDialogId: 'day1_opening20c',
    },
    day1_opening20c: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: ``,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/kamar_diana.png',
      choices: [
        {
          text: 'Tentu saja, kita langsung bertemu di Danau besok sore?',
          nextDialogId: 'day1_opening20d',
        },
        {
          text: 'Aku tidak sabar menunjukan Elsa tempat kita suka berendam.',
          nextDialogId: 'day1_opening20d',
        },
        {
          text: 'Asik, aku tidak sabar, mengenang aktivitas favorit kita di masa kecil.',
          nextDialogId: 'day1_opening20d',
        },
      ],
    },
    day1_opening20d: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Baik kalau begitu, sampai jumpa besok sore ya.`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/kamar_diana.png',
      nextDialogId: 'day1_opening22',
    },
    day1_opening21: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Sudah malam, sebaiknya kakak juga kembali ke kamar dan beristirahat`,
      characterImage: '/assets/character/v2/diana.png',
      backgroundImage: '/assets/backdrop/kamar_diana.png',
      nextDialogId: 'day1_opening22',
    },
    day1_opening22: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.png',
      nextDialogId: 'day1_op1',
      sfx : "openDoor"
    },

    day1_op1: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Ini adalah kamar masa kecil ku`,
      backgroundImage: '/assets/backdrop/kamar_yan.png',
      sfx : "",
      nextDialogId: 'day1_op2',
    },
    day1_op2: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Sayangnya ranjang ku tidak nyaman untuk dua orang`,
      backgroundImage: '/assets/backdrop/kamar_yan.png',
      sfx : "",
      nextDialogId: 'day1_opening23',
    },

    day1_opening23: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Saatnya beristirahat....`,
      backgroundImage: '/assets/cutscene/black.png',
      sfx : "",
      nextDialogId: 'part2_1',
    },

    ...part2Dialog
  },
};
export default config;
